<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col
        align="center"
        justify="center">
          <v-img
            width="160px"
            src="https://pjili-public.s3.ca-central-1.amazonaws.com/global/images/pjili-logo-sm.png"
          ></v-img>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center">
      <v-col>
        <h1 class="text-center mb-5">Welcome to Pjili!</h1>

        <v-card
          class="mx-auto"
          max-width="400"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content class="text-center">
              <v-list-item-title class="headline">Code from the SMS</v-list-item-title>
              <v-list-item-subtitle>We sent you a text message with a confirmation code, please enter it below to continue.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-alert
              v-if="hasErrors()"
              color="warning">
              <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
              </ul>
            </v-alert>
            <v-form>
              <v-text-field
                v-model.trim="Otp"
                v-on:keydown.enter.prevent="submit"
                name="Otp"
                label="Code"
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="submit()"
              rounded
              :loading="loading"
              color="info"
              dark>
              Next
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SignupVerifyPhone",
  data() {
    return {
      Otp: null,
      loading: false,
      errors: []
    };
  },
  computed: {
    signUpIntent() {
      return this.$store.state.signupintent.signUpIntent
    }
  },
  mounted() {
    if (this.$store.state.signupintent.signUpIntent === null) {
      this.$router.push({ name: 'signup-start' })
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$axios.post('/signup/otp-verify', { Intent: this.signUpIntent.Id, Otp: this.Otp, Phone: this.signUpIntent.Phone})
        .then(() => {
          this.$router.push({ name: 'signup-finish' })
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            this.errors = error.response.data.errors
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.errors = ["Network error"]
          } else {
            // Something happened in setting up the request that triggered an Error
            this.errors = ["We're really sorry our systems seems to be unhealty now. Please try again later or contact us."]
          }
          this.loading = false
        })
    },
    hasErrors() {
      return this.errors.length > 0
    }
  }
}
</script>